export const unsupportedCharacters = [
  {
    value: '#',
    replacable: '[[hash]]'
  }
];
